<template>
    <div class="text-left mt-2">
        <div class="d-flex gap-2 my-1">
            <div class="square-status square-status-ok">
                <b-icon icon="check" color="white" font-scale="1" aria-hidden="true"></b-icon>
            </div>
            <span>Tous les coureurs attendus sont passés</span>
        </div>
        <div class="d-flex gap-2 my-1">
            <div class="square-status square-status-waiting">
                <b-icon icon="three-dots" color="white" font-scale="1" aria-hidden="true"></b-icon>
            </div>
            <span>Des coureurs sont encore attendus</span>
        </div>
        <div class="d-flex gap-2 my-1">
            <div class="square-status square-status-late">
                <b-icon icon="exclamation" color="white" font-scale="1" aria-hidden="true"></b-icon>
            </div>
            <span>Des coureurs sont en retard</span>
        </div>


    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.square-status {
    width: 20px;
    height: 20px;

    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.square-status-ok {
    background-color: #00614c;
}

.square-status-late {
    background-color: #46001b;
}

.square-status-waiting {
    background-color: #b85300;
}
</style>